import {
  HIGH_COMPETITION,
  isGigKind,
  type GigApplication,
  type GigListing,
} from "../../api/gigboard";
import type { Track } from "../../api/types";
import { Button } from "../../components/Button";
import { safeHref } from "../../lib/format";
import { agoText, boardTrackLabel, statusLabel } from "./gigFormat";

/** One listing. Apply opens the "Leaving to apply" step rather than going straight out. */
export function GigCard({
  listing,
  application,
  myTrack,
  trackLabels,
  onApply,
}: {
  listing: GigListing;
  application?: GigApplication | null | undefined;
  myTrack: Track;
  trackLabels: Record<Track, string>;
  onApply: () => void;
}) {
  const hot = listing.bids != null && listing.bids >= HIGH_COMPETITION;
  const site = safeHref(listing.site);
  const gig = isGigKind(listing.kind);
  const posted = agoText(listing.posted);
  return (
    <article className="flex flex-col gap-1.5 rounded-[var(--radius-card)] border border-border bg-surface p-4 transition-colors hover:border-accent">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] font-bold uppercase tracking-[0.08em] text-text-muted">
          {site ? (
            <a href={site} target="_blank" rel="noopener" className="hover:text-accent">
              {listing.source}
            </a>
          ) : (
            listing.source
          )}
        </span>
        {listing.kind || listing.track !== myTrack ? (
          <span
            className={`rounded-full px-2.5 py-0.5 text-[11.5px] font-bold ${
              gig ? "bg-positive-tint text-positive" : "bg-surface-high text-text"
            }`}
          >
            {listing.kind}
            {listing.track !== myTrack
              ? `${listing.kind ? " · " : ""}${boardTrackLabel(listing.track, trackLabels)}`
              : ""}
          </span>
        ) : null}
      </div>
      <h3 className="m-0 mt-0.5 text-[18px] leading-[1.15] text-text">{listing.title}</h3>
      <div className="text-[13px] text-text-muted">
        {listing.company}
        {listing.company && listing.loc ? " · " : ""}
        {listing.loc}
      </div>
      {listing.pay ? <div className="text-[16px] font-bold text-accent">{listing.pay}</div> : null}
      {listing.desc ? (
        <p className="m-0 my-0.5 line-clamp-3 text-[13.5px] text-text">{listing.desc}</p>
      ) : null}
      <div className="mt-auto flex justify-between gap-2 border-t border-border pt-2 text-[12px] text-text-muted">
        <span>
          {posted}
          {listing.bids != null
            ? `${posted ? " · " : ""}${listing.bids} ${listing.bids === 1 ? "bid" : "bids"} so far`
            : ""}
          {hot ? <b className="ml-1 text-negative">High competition</b> : null}
        </span>
        {application ? (
          <span className="font-bold text-positive">✓ {statusLabel(application.status)}</span>
        ) : null}
      </div>
      <div className="mt-1.5">
        <Button size="sm" onClick={onApply}>
          {listing.direct ? "Apply now" : `Apply on ${listing.source}`} ↗
        </Button>
      </div>
    </article>
  );
}
